import { render } from "./TradeMainTop.vue?vue&type=template&id=19833702"
import script from "./TradeMainTop.vue?vue&type=script&lang=js"
export * from "./TradeMainTop.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__